<template>
  <div>
    <h3 class="modal-title"> HIERARCHY </h3>

    <b-form-group :class="{'error-input' : $v.data_hierarchy.title.$error}">
      <label> Hierarchy Title </label>
      <j-input
        v-model="$v.data_hierarchy.title.$model"
        :max-length="255"
        placeholder="Hierarchy Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_hierarchy.endpoint_top_hierarchy.$error}">
      <label> Endpoint Top Hierarchy </label>
      <j-input
        v-model="$v.data_hierarchy.endpoint_top_hierarchy.$model"
        placeholder="Endpoint Top Hierarchy"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_hierarchy.endpoint_list_hierarchy.$error}">
      <label> Endpoint List Hierarchy </label>
      <j-input
        v-model="$v.data_hierarchy.endpoint_list_hierarchy.$model"
        placeholder="Endpoint List Hierarchy"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeHierarchy">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveHierarchy">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_hierarchy: {
      title: {
        required,
      },
      endpoint_top_hierarchy: {
        required,
      },
      endpoint_list_hierarchy: {
        required,
      },
    },
  },
  data() {
    return {
      data_hierarchy: {
        title: '',
        endpoint_top_hierarchy: '',
        endpoint_list_hierarchy: '',
      },
    };
  },
  computed: {

    generateDataHierarchy() {
      const data = {
        info: JSON.stringify({
          endpoint_top_hierarchy: this.data_hierarchy.endpoint_top_hierarchy,
          endpoint_list_hierarchy: this.data_hierarchy.endpoint_list_hierarchy,
        }),
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_hierarchy.title,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },

    generateDataHierarchyUpdate() {
      const data = {
        info: JSON.stringify({
          endpoint_top_hierarchy: this.data_hierarchy.endpoint_top_hierarchy,
          endpoint_list_hierarchy: this.data_hierarchy.endpoint_list_hierarchy,
        }),
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_hierarchy.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_hierarchy = {
        endpoint_top_hierarchy: JSON.parse(this.dataEdit.info).endpoint_top_hierarchy,
        endpoint_list_hierarchy: JSON.parse(this.dataEdit.info).endpoint_list_hierarchy,
      };
      this.data_hierarchy.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveHierarchy() {
      this.$v.data_hierarchy.$touch();
      if (!this.$v.data_hierarchy.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataHierarchy,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataHierarchyUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeHierarchy();
      }
    },

    closeHierarchy() {
      this.$emit('close-field');
      this.data_hierarchy.title = '';
      setTimeout(() => {
        this.$v.data_hierarchy.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jCustomHierarchySetup.vue